import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center">
      <p className="font-heading text-7xl font-black text-background-300 select-none md:text-9xl">
        404
      </p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        没有找到 <span className="font-mono text-foreground-700">{location.pathname}</span> 对应的内容
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-lg" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          <i className="ri-search-line text-lg" />
          去搜索作品
        </Link>
      </div>
    </div>
  );
}